import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { TourReactStep } from 'webapp/models-custom/tour-react';
import TourReactBase from 'webapp/models-custom/tour-react';

export default class GenieArtifactEditTour extends TourReactBase {
	static keyForPersistantDone = UserSettingsKey.GENIE_ARTIFACT_EDIT;

	get id(): string {
		return TourId.GENIE_ARTIFACT_EDIT;
	}

	override get keyForPersistantDone(): string {
		return GenieArtifactEditTour.keyForPersistantDone;
	}

	get steps(): TourReactStep[] {
		return [
			{ id: 'artifact-edit', anchorId: 'artifact-edit', side: 'bottom', align: 'center' },
		];
	}
}
